import { getItem, setItem } from "./storage";
export function getPeriodDate(date) {
  if (!date) {
    date = new Date();
  }
  const y = date.getFullYear();
  const m =
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const d = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  return `${y}-${m}-${d}`;
}

export function getPeriod() {
  if (getItem("accountPeriod")) {
    if (getItem("accountPeriod") === "2019-00") {
      setItem("accountPeriod", "2018-12");
      return "2018-12";
    } else {
      return getItem("accountPeriod");
    }
  } else {
    const date = new Date();

    let y = date.getFullYear();
    let m;
    if (date.getMonth() === 0) {
      y = y - 1;
      m = 12;
    } else {
      m = date.getMonth() < 10 ? `0${date.getMonth()}` : date.getMonth();
    }
    const period = `${y}-${m}`;
    setItem("accountPeriod", period);
    return period;
  }
}

export async function getPeriodYYMM(period) {
  if (!period || period.indexOf("-") === -1) {
    return "";
  }
  return `${period.split("-")[0]}年${period.split("-")[1]}月`;
}

/*
 * 参数说明：
 * s：要格式化的数字
 * n：保留几位小数
 * */
export function moneyFormat(s, n) {
  if (!s && s !== 0) {
    return;
  }
  n = n > 0 && n <= 20 ? n : 2;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
  let l = s.split(".")[0].split("").reverse();
  let r = s.split(".")[1];
  let t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? "," : "");
  }
  return "￥" + t.split("").reverse().join("") + "." + r;
}

export function reversalMoney(value) {
  if (!value) {
    return;
  }
  return Number(value.slice(1).replace(/,/g, ""));
}

export function changeTitle(title) {
  document.title = title;
  //解决document.title 在 ios 下不生效bug方案 ios内生效
  const mobile = navigator.userAgent.toLowerCase();
  // const length = document.querySelectorAll('iframe').length;
  const nodeList = document.querySelectorAll("iframe");
  if (nodeList.length) {
    document.body.removeChild(nodeList[0]);
  }
  if (/iphone|ipad|ipod/.test(mobile)) {
    const iframe = document.createElement("iframe");
    iframe.style.cssText = "display: none; width: 0; height: 0;";
    iframe.setAttribute("src", "about:blank");
    iframe.addEventListener("load", () => {
      setTimeout(() => {
        iframe.removeEventListener("load", () => {}, false);
      }, 0);
    });
    document.body.appendChild(iframe);
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js